module.exports = __webpack_public_path__ + "static/media/spinner.058e016f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/spinner.svg
// module id = 789
// module chunks = 0